module.exports = __webpack_public_path__ + "static/media/slider-right-white.838e6b01.cur";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/slider-right-white.cur
// module id = 68
// module chunks = 0